import { getDomainCfg } from "../core/state";
import { getAppVersion } from "../core/version";

export async function getJson(request: RequestInfo): Promise<any> {
  try {
    const response = await fetch(request);
    const body = await response.json();
    return body;
  } catch (e) {
    console.error("Couldnt load Json Ressource", request);
  }
  return { invalid : true };
}

export async function getNonCachedJson(request: string): Promise<any> {
  try {
    const options : RequestInit = {
      cache : 'no-store',
      headers: {
        'Cache-Control' : 'no-cache, no-store, must-revalidate'
      }
    };

    const versionParam = `?v=${getAppVersion()}`;
    const requestWithVer = request + versionParam
    const response = await fetch(requestWithVer, options);
    const body = await response.json();
    return body;
  } catch (e) {
    console.error("Couldnt load Json Ressource", request);
  }
  return { invalid : true };
}

export async function getFileContent(request:RequestInfo) : Promise<string> {
  try {
    const response = await fetch(request);
    if (response.ok) {
      const body = await response.text();
      return body;
    }
  } catch (e) {
    console.error("Couldnt load File Content", request);
  }
  return "";
}

export async function doRequest(url : string, settings : any) : Promise<any> {
  try {
    const response = await fetch(url, settings);
    //console.log("got response", response);
    const body = await response.json();
    return {
      success: response.ok,
      status: response.status,
      ...body
    };
    } catch (e) {
      console.error("Couldnt finish request to " + url, e);
    }
    return { invalid : true };
}

export async function requestTextContent(url : string, settings : any) : Promise<any> {
  try {
    const response = await fetch(url, settings);
    console.log("got response", response);
    const body = await response.text();
    return body;
    } catch (e) {
      console.error("Couldnt finish request to " + url, e);
    }
    return "";
}

export async function postMessage(message: string, messages: any[]): Promise<any> {
  try {
    const options: RequestInit = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate'
      },
      body: JSON.stringify({ message: message, history: messages })
    };

    const response = await fetch(getDomainCfg().chatSettings.chatUrl, options);

    if (!response.ok) {
      console.error('Server responded with an error:', response.status);
      return {
        error: true,
        status: response.status,
        message: response.statusText
      };
    }

    const responseBody = await response.json();

    return {
      error: false,
      messageText: responseBody.message.text,
      docs: responseBody.message.docs
    };
  } catch (e) {
    console.error("Couldn't send the message", e);
    return {
      error: true,
      message: e.toString()
    };
  }
}